import type {
  PatchDocumentsRequestType,
  PatchDocumentsResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const patchDocuments = async (body: PatchDocumentsRequestType) => {
  const url = `/api/v2/documents`;
  const response = await apiAuthClient.patch<PatchDocumentsResponseType>(
    url,
    body,
  );

  return response.data;
};
